import script from "./LetterOfAppointmentDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./LetterOfAppointmentDialog.vue?vue&type=script&setup=true&lang=js"

import "./LetterOfAppointmentDialog.vue?vue&type=style&index=0&id=2dc21898&lang=scss"

const __exports__ = script;

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/.pnpm/vue-cli-plugin-quasar@5.0.2/node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QCardSection,QCardActions,QBtn,QSpinner});qInstall(script, 'directives', {ClosePopup});
